// import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Util from './libs/util';
import { post, get } from './libs/axios';
import store from './store'
import $ from 'jquery';
require('swiper/dist/css/swiper.css')
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
Vue.prototype.util = Util;
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.config.productionTip = false;
window.jQuery = $;
window.$ = $;
Util.getUserAgent();

router.beforeEach((to, from, next) => {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('micromessenger') != -1 && !sessionStorage.getItem('getjsapi')) {
        getjsAPI(to);
    }
    if (typeof(to.meta.historyHref) == 'undefined' || to.meta.historyHref == '') {
        store.commit('addKeep', to.meta.name);
    } else {
        if (to.meta.historyHref != window.location.href) {
            store.commit('minusKeep', to.meta.name)
        } else {
            store.commit('addKeep', to.meta.name)
        }
    }
    next();
})
router.afterEach((to, from, next) => {
    setTimeout(function() {
        if (to.meta.historyHref != window.location.href) {
            if (typeof(to.meta.historyHref) == 'undefined' || store.state.state.keepAlive.indexOf(to.meta.name) == -1) {
                window.scrollTo(0, 0);
            }
            store.commit('addKeep', to.meta.name);
        } else {
            if (store.state.state.keepAlive.indexOf(to.meta.name) == -1) {
                window.scrollTo(0, 0);
            }
        }
        to.meta.historyHref = window.location.href;
    })
})

function getjsAPI(to) {
    get('/gart-common-api/wx/mp/jsAPI', {
        url: location.href.split('#')[0]
    }).then(res => {
        if (res.code == 1) {
            sessionStorage.setItem('getjsapi', 1);
            var data = res.data;
            wx.config({ //调用微信js-sdk
                // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: data.appId, // 必填，公众号的唯一标识
                timestamp: data.timestamp, // 必填，生成签名的时间戳
                nonceStr: data.nonce, // 必填，生成签名的随机串
                signature: data.signature, // 必填，签名
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'chooseWXPay', 'hideMenuItems', 'showMenuItems'] // 必填，需要使用的JS接口列表
            });
        } else {
            Util.toast({
                msg: res.message
            });
        }
    })
    setTimeout(function() {
        wx.checkJsApi({
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'chooseWXPay', 'hideMenuItems', 'showMenuItems'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function(res) {
                // 以键值对的形式返回，可用的api值true，不可用为false
                // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                if (to.name == '/common/play') {
                    wx.hideMenuItems({
                        menuList: ['menuItem:share:appMessage',
                            'menuItem:share:timeline',
                            'menuItem:share:qq',
                            'menuItem:share:weiboApp',
                            'menuItem:share:facebook',
                            'menuItem:share:QZone'
                        ]
                    });
                } else {
                    wx.showMenuItems({
                        menuList: ['menuItem:share:appMessage',
                            'menuItem:share:timeline',
                        ]
                    });
                    wx.hideMenuItems({
                        menuList: [
                            'menuItem:share:qq',
                            'menuItem:share:weiboApp',
                            'menuItem:share:facebook',
                            'menuItem:share:QZone'
                        ]
                    });
                }
            },
        });
    }, 1000)
}
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')